import {Button} from '@material-ui/core'
import {makeStyles} from '@material-ui/core/styles'
import DeleteIcon from '@material-ui/icons/Delete'
import React from 'react'

import {RoleHaulierLookupChip} from '../../../components/Role/deprecated/RoleHaulierLookupChip'
import {GroupedRoleAssignment} from '../../../modules/ManageUsers.selectors'

const useStyles = makeStyles(() => ({
  deleteButton: {
    minWidth: 'auto'
  },
  hauliersContainer: {
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: '#7F9BA6',
    borderRadius: '3px',
    marginTop: '5px',
    padding: '6px 6px 6px 8px',
    marginBottom: '-1px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start'
  }
}))

interface Props {
  groupedRoleAssignment: GroupedRoleAssignment
  isEditing: boolean
  handleDeleteHaulier?(haulierId: string): void
}

export const Hauliers: React.FC<Props> = ({
  groupedRoleAssignment,
  isEditing,
  handleDeleteHaulier
}) => {
  const classes = useStyles()

  const {haulierIds} = groupedRoleAssignment.variantDataScopes

  if (!haulierIds || haulierIds.length === 0) {
    return null
  }

  return (
    <div className="">
      <div className="">
        {groupedRoleAssignment.variantDataScopes.haulierIds?.map((haulierId) => (
          <div key={haulierId} className={classes.hauliersContainer}>
            <RoleHaulierLookupChip key={haulierId} haulierId={haulierId} />
            {isEditing && (
              <Button
                variant="text"
                color="secondary"
                className={classes.deleteButton}
                onClick={() => {
                  handleDeleteHaulier?.(haulierId)
                }}
              >
                <DeleteIcon />
              </Button>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}
